module.exports = __webpack_public_path__ + "static/a4-28bba3634c0399ba654e3e2bd7e6798d.png";